import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { UserPermissionsResponse } from "../models/permissions.model";

@Injectable({ providedIn: 'root' })
export class PermissionsService {

  private permissions: Record<string, boolean> = {};

  constructor(private http: HttpClient) { }

  loadPermissions(): Observable<UserPermissionsResponse> {
    return this.http.get<UserPermissionsResponse>(`${environment.backendUrl}/authentication/permissions`, {
      withCredentials: true
    }).pipe(
      tap(response => this.permissions = response.permissions ?? {})
    );
  }

  hasPermission(permission: string): boolean {
    return this.permissions[permission] === true;
  }

  hasAnyPermission(permissions: readonly string[]): boolean {
    return permissions.some(permission => this.hasPermission(permission));
  }
}
